import Moment from 'react-moment';

/**
 * Renders a date without a time component (DD-MMM-YYYY).
 *
 * @param {object} props
 * @param {boolean} [props.utc] - When true, render the date in UTC. Use this for
 *   values that represent a UTC calendar day (e.g. date filter values), so the
 *   displayed day is not shifted by the browser's local timezone.
 */
const NiceDateOnly = (props) => {

return (
    <Moment utc={props.utc} format="DD-MMM-YYYY">
      {props.children}
    </Moment>
  )
}

export default NiceDateOnly;
